/* eslint-disable */
import * as createHistory from 'history';

export const history = createHistory.createMemoryHistory<{
  scrollToId?: string;
}>();
